export default "__VITE_ASSET__BEx29fM9__"